module.exports = __webpack_public_path__ + "img/Paraguay.d3bb0512.svg";